import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export interface CompositionCounts {
  learned: number;
  repeat: number;
  notLearned: number;
  new: number;
  attention: number;
}

export const GROUPS: Array<{
  id: keyof CompositionCounts;
  label: string;
  color: string;
}> = [
  { id: 'learned', label: 'Вивчені', color: '#27CCBC' },
  { id: 'repeat', label: 'Повторити', color: '#777BFF' },
  { id: 'notLearned', label: 'Не вивчені', color: '#9B7CFF' },
  { id: 'new', label: 'Нові', color: '#3B2C93' },
  { id: 'attention', label: 'Без перекладу', color: '#FFC107' },
];

export const compTotal = (c: CompositionCounts) =>
  GROUPS.reduce((s, g) => s + (c[g.id] || 0), 0);

interface IACompositionBarProps {
  comp: CompositionCounts;
  height?: number;
  legend?: boolean;
  compact?: boolean;
}

const IACompositionBar: React.FC<IACompositionBarProps> = ({
  comp,
  height = 12,
  legend,
  compact,
}) => {
  const total = compTotal(comp) || 1;
  const segs = GROUPS.filter((g) => comp[g.id] > 0);

  return (
    <Box>
      <Box
        sx={{
          bgcolor: 'primary.purple',
          borderRadius: 999,
          display: 'flex',
          height,
          overflow: 'hidden',
        }}
      >
        {segs.map((g) => (
          <Box
            key={g.id}
            title={`${g.label}: ${comp[g.id]}`}
            sx={{
              bgcolor: g.color,
              width: `${(comp[g.id] / total) * 100}%`,
            }}
          />
        ))}
      </Box>
      {legend && (
        <Stack
          direction={'row'}
          sx={{
            flexWrap: 'wrap',
            gap: compact ? '8px 16px' : '10px 22px',
            mt: 1.75,
          }}
        >
          {GROUPS.map((g) => (
            <Stack
              key={g.id}
              direction={'row'}
              alignItems={'center'}
              spacing={1}
            >
              <Box
                sx={{
                  bgcolor: g.color,
                  borderRadius: '3px',
                  flex: 'none',
                  height: 11,
                  width: 11,
                }}
              />
              <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
                {comp[g.id] || 0}
              </Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: 13.5 }}>
                {g.label}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default IACompositionBar;
